import React from 'react';
import cn from 'classnames';
import stakeholderPattern from './assets/stakeholderPattern.svg';
import TabList from '@/dataroom/ui/components/Landing/Legacy/Sections/TabList';
import styles from './stakeholderBenefits.module.scss';
import baseStyles from '../../tenantInvestorSet.module.scss';
import IconCheckCircle from '@dealroadshow/uikit-icon/IconCheckCircle';
import { defaultTab, tabsContent, tabsMapping } from './Tabs';

const StakeholderBenefits = () => {
  const renderBenefitItem = (item: { key: string, title?: string, description?: React.ReactNode }) => (
    <li key={ item.key }>
      <IconCheckCircle className={ styles.tabBenefitTick } />
      <h3 className={ styles.tabBenefitTitle }>{ item.title }</h3>
      <div className={ styles.tabBenefitDescription }>{ item.description }</div>
    </li>
  );

  const renderTabContent = (item: { value: string }) => {
    const content = (tabsContent as unknown as Record<string, {
      logo: string,
      title: string,
      benefits: { key: string, title?: string, description?: React.ReactNode }[],
    }>)[item.value];

    return (
      <div className={ styles.tabContentWrp }>
        <div className={ styles.tabHeading }>
          <img
            className={ styles.tabLogo }
            src={ content.logo }
          />
          <div className={ styles.tabTitle }>{ content.title }</div>
        </div>
        <ul className={ styles.tabBenefits }>{ content.benefits.map(renderBenefitItem) }</ul>
      </div>
    );
  };

  return (
    <div className={ styles.stakeholderContainer }>
      <div className={ baseStyles.mdContainer }>
        <div className={ baseStyles.sectionTitle }>
          Access drives activity in capital markets
        </div>
        <div className={ cn(baseStyles.sectionDescription, styles.description) }>
          InvestorSet reduces friction and broadens awareness of your securities,
          which ultimately improves liquidity. Below are other benefits for each stakeholder:
        </div>
      </div>
      <div className={ styles.stakeholderPattern }>
        <img src={ stakeholderPattern.src } />
      </div>
      <TabList
        tabs={ tabsMapping }
        defaultTab={ defaultTab }
        className={ styles.stakeholderTabs }
        selectClassName={ styles.stakeholderSelect }
        renderTabContent={ renderTabContent }
      />
    </div>
  );
};

export default StakeholderBenefits;
